import FJFaceSwapData from '../../config/dataConfig/FJFaceSwapData';
import FJConfig from '../../config/FJConfig';
import FJVersionConfig from '../../config/FJVersionConfig';
import FJConstant from '../../constants/FJConstant';
import FJImageStore from '../../store/FJImageStore';
import FJLocalStore from '../../store/FJLocalStore';
import FJMessageStore from '../../store/FJMessageStore';
import FJNetworkStore from '../../store/FJNetworkStore';
import FJFileHandleUtil from '../../util/FJFileHandleUtil';
import FJUtil from '../../util/FJUtil';
import { setSliceCreationListAction, setSliceTaskStatusAction } from '../slices/FJSliceCommon';
import {
    setSliceMobileStep,
    setSliceOriginCurLoadName,
    setSliceOriginUploadImageInfo,
    setSliceTargetCurLoadName,
    setSliceTargetUploadImageInfo,
} from '../slices/FJSliceFaceSwap';
import { setSliceLoadingModalData } from '../slices/FJSliceModals';
import { setSliceIsShowPresetImageBox } from '../slices/FJSliceTextToImage';
import FJActionCommon from './FJActionCommon';
import FJActionModal from './FJActionModal';

let f_startGenerateTime = null;
const FJActionFaceSwap = {
    resetAction: function () {
        return dispatch => {
            dispatch(setSliceOriginUploadImageInfo({}));
            dispatch(setSliceTargetUploadImageInfo({}));
        };
    },
    /**
     * @desc 修改上传的图片信息
     * @param {*} payload
     * @returns
     */
    uploadOriginImageAction: function (file) {
        return dispatch => {
            const isGif = FJFileHandleUtil.isGIF(file);
            if (isGif) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                return;
            }

            FJUtil.loadImageFile(
                file,
                img => {
                    const info = {
                        src: img.src,
                        width: img.width,
                        height: img.height,
                    };

                    dispatch(setSliceOriginUploadImageInfo(info));
                    FJUtil.isMobile && dispatch(setSliceMobileStep(1));
                },
                () => {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                        'error',
                    );
                },
            );
        };
    },
    updateOriginImageUrlAction: function (url, options = {}) {
        return dispatch => {
            const { size, name, id } = options;
            const info = { src: url, width: size.width, height: size.height, id: id, name: name };
            dispatch(setSliceOriginUploadImageInfo(info));
        };
    },

    /**
     * @desc 修改上传的图片信息
     * @param {*} payload
     * @returns
     */
    uploadTargetImageAction: function (file, callback) {
        return async dispatch => {
            const isGif = FJFileHandleUtil.isGIF(file);
            if (isGif) {
                FJMessageStore.addMessage(
                    FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                    'error',
                );
                return;
            }
            const fileId = await FJUtil.hashEncode(file);
            FJUtil.loadImageFile(
                file,
                img => {
                    const info = {
                        src: img.src,
                        width: img.width,
                        height: img.height,
                        id: fileId,
                    };

                    dispatch(setSliceTargetUploadImageInfo(info));
                    callback && callback(info);
                },
                () => {
                    FJMessageStore.addMessage(
                        FJLocalStore._('unsupported-format-please-try-again-with-supported-formats'),
                        'error',
                    );
                },
            );
        };
    },
    updateTargetImageUrlAction: function (url, options = {}) {
        return dispatch => {
            const { size, id, name } = options;
            const info = {
                src: url,
                width: size.width,
                height: size.height,
                id: id,
                name: name,
            };

            dispatch(setSliceTargetUploadImageInfo(info));
        };
    },

    generateAction: function () {
        return async (dispatch, getState) => {
            const { originUploadImageInfo, targetUploadImageInfo } = getState().faceSwap;
            const { creditNumber, freeNumCreation } = getState().common;
            const taskStatus = getState().common.taskStatus;

            FJUtil.eaLog('image face swap generate click');
            f_startGenerateTime = new Date().getTime();

            if (FJUtil.isGeneratingStatus(taskStatus)) return;

            if (
                !originUploadImageInfo ||
                !originUploadImageInfo.src ||
                !targetUploadImageInfo ||
                !targetUploadImageInfo.src
            ) {
                FJMessageStore.addMessage(
                    FJLocalStore._('please-upload-an-original-image-or-face-image-first'),
                    'error',
                );
                return;
            }

            const __errorCallback = failTaskCount => {
                if (!failTaskCount) {
                    dispatch(setSliceCreationListAction([]));
                } else {
                    const creationList = [...getState().common.creationList];

                    const allTaskListLength = creationList.length;

                    for (let i = allTaskListLength - failTaskCount; i < allTaskListLength; i++) {
                        creationList[i].isLoading = false;
                        creationList[i].isReload = true;
                    }
                    dispatch(setSliceCreationListAction(creationList));
                }

                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                FJUtil.isMobile() && dispatch(setSliceLoadingModalData({ display: false }));
            };

            let isFree = false;
            const __judgeCanGenerate = async () => {
                const userSpaceType = await FJUtil.checkUserSpace({
                    errorCallback: () => {
                        FJMessageStore.addMessage(
                            FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                            'error',
                        );
                    },
                });
                if (userSpaceType > 0) {
                    dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                    return false;
                }
                const useCredit = 2;
                const canFreeCreate = freeNumCreation > 0;
                isFree = creditNumber < useCredit && canFreeCreate;
                if (creditNumber < useCredit && !canFreeCreate) {
                    dispatch(FJActionModal.showUpgradeModalAction());
                    return false;
                }
                return true;
            };

            // 修改状态生成占位符
            const placeHolderList = FJUtil.createPlaceHolderListNew({
                count: 1,
                width: originUploadImageInfo.width,
                height: originUploadImageInfo.height,
                type: FJConstant.CREATIONS,
            });

            dispatch(FJActionCommon.setHeaderTabIndexAction(0));
            dispatch(setSliceIsShowPresetImageBox(false));
            dispatch(setSliceCreationListAction(placeHolderList));
            dispatch(setSliceTaskStatusAction(FJConstant.START));
            FJUtil.isMobile() &&
                dispatch(setSliceLoadingModalData({ display: true, message: FJLocalStore._('generating') + '...' }));
            const isCanGenerate = await __judgeCanGenerate();

            if (!isCanGenerate) {
                __errorCallback();
                return;
            }

            // 上传原图
            const originImageUrl = originUploadImageInfo.isPresetImage
                ? originUploadImageInfo.src
                : await FJImageStore.upLoadFileToS3ByUrl(originUploadImageInfo.src);
            if (!originImageUrl) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-generate-the-image-please-try-it-again'), 'error');
                return;
            }

            // 上传目标图
            const targetImageUrl = targetUploadImageInfo.isPresetImage
                ? targetUploadImageInfo.src
                : await FJImageStore.upLoadFileToS3ByUrl(targetUploadImageInfo.src);

            if (!targetImageUrl) {
                FJMessageStore.addMessage(FJLocalStore._('failed-to-generate-the-image-please-try-it-again'), 'error');
                return;
            }

            // 生成图片
            const __request = async () => {
                return await FJNetworkStore.faceSwap(originImageUrl, targetImageUrl);
            };

            const eventId = await FJActionCommon.createRequestTask(__request, dispatch);
            FJUtil.updateAllCreditInfo();

            const tool = FJUtil.getToolName();
            FJUtil.eaLog('ai tool start generating', { 'credit&free': isFree ? 'free' : 'credit', tool });

            // 3. 轮询任务状态
            const callback = data => {
                const { type } = data;

                if (type === FJConstant.ERROR) {
                    FJMessageStore.addMessage(
                        FJLocalStore._('failed-to-generate-the-image-please-try-it-again'),
                        'error',
                    );
                    __errorCallback();
                }

                if (type === FJConstant.SUCCESS) {
                    FJUtil.isMobile() && dispatch(setSliceLoadingModalData({ display: false }));

                    let endTime = new Date().getTime();
                    const generatingDuration = FJUtil.getTimeDiff(f_startGenerateTime, endTime);

                    FJUtil.eaLog('image face swap generate success', {
                        'generating duration': generatingDuration,
                    });
                    FJUtil.eaLog('ai tool generate success', {
                        tool: FJUtil.getToolName(),
                        'credit&free': isFree ? 'free' : 'credit',
                    });
                }

                // 将失败的任务更改为失败状态
                if (type === FJConstant.SUCCESS && data.failTaskCount > 0) {
                    __errorCallback(data.failTaskCount);
                }
            };

            dispatch(
                FJActionCommon.pollingTaskAction([eventId], {
                    callback,
                    autoDefaultTaskStatus: !FJUtil.isMobile(),
                    isUseFree: isFree,
                }),
            );
        };
    },

    /**
     * @desc 加载图片
     * @param {string} imageUrl
     * @returns
     */
    _loadImage: async function (imageUrl) {
        return await new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => resolve(image);
            image.onerror = () => reject(new Error(`Failed to load image: ${imageUrl}`));
            image.src = imageUrl;
        });
    },

    /**
     * @desc 上传原图试一试
     * @param {*} item
     * @returns
     */
    uploadOriginTryThoseImageAction: function (item) {
        return async dispatch => {
            dispatch(setSliceOriginCurLoadName(item.name));
            const imageName = item.name + '.png';
            const imageUrl = FJConfig.thoseOriginImagesPath + imageName + '?v=' + FJVersionConfig.staticPathVersion;

            const originIndex = FJFaceSwapData.THOSE_ORIGIN_IMAGES.findIndex(img => img.name === item.name);

            FJUtil.eaLog('image face swap preset image click', {
                'original image': originIndex + 1,
            });

            try {
                const image = await this._loadImage(imageUrl);

                const info = {
                    src: image.src,
                    width: image.width,
                    height: image.height,
                    isPresetImage: true,
                };

                dispatch(setSliceOriginUploadImageInfo(info));
                FJUtil.isMobile && dispatch(setSliceMobileStep(1));
            } catch (error) {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
            } finally {
                dispatch(setSliceOriginCurLoadName(''));
            }
        };
    },

    /**
     * @desc 上传目标图试一试
     * @param {*} item
     * @returns
     */
    uploadTargetTryThoseImageAction: function (item, callback) {
        return async dispatch => {
            dispatch(setSliceTargetCurLoadName(item.name));
            const imageName = item.name + '.png';
            const imageUrl = FJConfig.thoseTargetImagesPath + imageName + '?v=' + FJVersionConfig.staticPathVersion;
            const targetIndex = FJFaceSwapData.THOSE_TARGET_IMAGES.findIndex(img => img.name === item.name);

            FJUtil.eaLog('image face swap preset image click', {
                'target image': targetIndex + 1,
            });

            try {
                const image = await this._loadImage(imageUrl);

                const info = {
                    src: image.src,
                    width: image.width,
                    height: image.height,
                    isPresetImage: true,
                };

                dispatch(setSliceTargetUploadImageInfo(info));
                callback && callback(info);
            } catch (error) {
                FJMessageStore.addMessage(FJLocalStore._('network-error-please-try-again'), 'error');
            } finally {
                dispatch(setSliceTargetCurLoadName(''));
            }
        };
    },
};

export default FJActionFaceSwap;
